import store from '@state/store'

//when in production mode
const routeSubDirectory='/gebi'

//when in dev mode
//const routeSubDirectory=''

// auth related routes
const authRoutes = [
  {
    path: routeSubDirectory+'/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/pages/account/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'Dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: routeSubDirectory+'/signin',
    name: 'signin',
    component: () => lazyLoadView(import('@views/pages/account/signin')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'Dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: routeSubDirectory+'/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/pages/account/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'Dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: routeSubDirectory+'/confirm-account',
    name: 'confirm-account',
    component: () => lazyLoadView(import('@views/pages/account/confirm')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'Dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: routeSubDirectory+'/forget-password',
    name: 'forget-password',
    component: () =>
      lazyLoadView(import('@views/pages/account/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'Dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: routeSubDirectory+'/verify',
    name: 'verify',
    component: () =>
      lazyLoadView(import('@views/pages/account/verify')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'Dashboard' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: routeSubDirectory+'/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: 'login' } : { ...routeFrom }
        )
      },
    },
  },
]

// error pages
const errorPagesRoutes = [
  {
    path: routeSubDirectory+'/404',
    name: '404',
    component: require('@views/pages/secondary/error-404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: routeSubDirectory+'/500',
    name: '500',
    component: require('@views/pages/secondary/error-500').default,
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]


function getDashboardUrl() {
  if (store.state.auth.currentUser) {
    if (store.state.auth.currentUser.accessLevel == 'Administrator')
      return lazyLoadView(import('@views/pages/dashboard/dashboard'))
    else if (store.state.auth.currentUser.accessLevel == 'User')
      return lazyLoadView(import('@views/pages/dashboard/dashboard-user'))
    else if (store.state.auth.currentUser.accessLevel == 'Union Administrator')
      return lazyLoadView(import('@views/pages/dashboard/dashboard-union'))
    else if (store.state.auth.currentUser.accessLevel == 'Federation Administrator')
      return lazyLoadView(import('@views/pages/dashboard/dashboard-federation'))
    else if (store.state.auth.currentUser.accessLevel == 'Editor')
      return lazyLoadView(import('@views/pages/dashboard/dashboard-editor'))
  }
  else
    return lazyLoadView(import('@views/pages/dashboard/dashboard-user'))
}

// admin dashboard
const dashboardRoutes = [
  {
    path: routeSubDirectory+'/',
    name: 'Dashboard',
    label: 'Courses',
    //labelKey:'nav.dashboard',
    header: 'Navigation',
    headerKey:'nav.navigation',
    icon: 'grid',
    component: () => getDashboardUrl(),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// // user dashboard
// const userDashboardRoutes = [
//   {
//     path: routeSubDirectory+'/dashboard-user',
//     name: 'User Dashboard',
//     header: 'Navigation',
//     icon: 'home',
//     badge: {
//       text: '1',
//       varient: 'success',
//     },
//     component: () => lazyLoadView(import('@views/pages/dashboard/dashboard-user')),
//     meta: { authRequired: true },
//     props: (route) => ({ user: store.state.currentUser || {} }),
//   },
// ]

// // union admin dashboard
// const unionDashboardRoutes = [
//   {
//     path: routeSubDirectory+'/dashboard-union',
//     name: 'Union Dashboard',
//     header: 'Navigation',
//     icon: 'home',
//     badge: {
//       text: '1',
//       varient: 'success',
//     },
//     component: () => lazyLoadView(import('@views/pages/dashboard/dashboard-union')),
//     meta: { authRequired: true },
//     props: (route) => ({ user: store.state.currentUser || {} }),
//   },
// ]

// // editor dashboard
// const editorDashboardRoutes = [
//   {
//     path: routeSubDirectory+'/dashboard-editor',
//     name: 'Editor Dashboard',
//     header: 'Navigation',
//     icon: 'home',
//     badge: {
//       text: '1',
//       varient: 'success',
//     },
//     component: () => lazyLoadView(import('@views/pages/dashboard/dashboard-editor')),
//     meta: { authRequired: true },
//     props: (route) => ({ user: store.state.currentUser || {} }),
//   },
// ]

const checkAgentPermissions = () => {
  return true
}



const logRoutes = [
  {
    path: routeSubDirectory+'/log',
    name: 'Log',
    labelKey:'nav.log',
    header:'Log',
    headerKey:'nav.log',
    icon: 'align-left',
    component: () => lazyLoadView(import('@views/pages/apps/log/log')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// member
const memberRoutes = [
  {
    path: routeSubDirectory+'/member',
    name: 'Member',
    labelKey:'nav.member',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/member/member')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// union member
const unionMemberRoutes = [
  {
    path: routeSubDirectory+'/member',
    name: 'Member',
    header: 'Membership',
    headerKey:'nav.membership',
    labelKey:'nav.member',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/member/member')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add member
const addMemberRoute = [
  {
    path: routeSubDirectory+'/member/add',
    name: 'Add Member',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/member/add-member')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view member
const viewMemberRoute = [
  {
    path: routeSubDirectory+'/member/view',
    name: 'View Member',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/member/view-member')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit member
const editMemberRoute = [
  {
    path: routeSubDirectory+'/member/edit',
    name: 'Edit Member',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/member/edit-member')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit member once after verification
const editMemberOnceRoute = [
  {
    path: routeSubDirectory+'/member/complete_memeber_information',
    name: 'Edit Member Once',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/member/edit-member-once')),
    meta: { authRequired: false },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]



// event
const eventRoutes = [
  {
    path: routeSubDirectory+'/event',
    name: 'Event',
    labelKey:'nav.event',
    icon: 'calendar',
    component: () => lazyLoadView(import('@views/pages/apps/event/event')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add event
const addEventRoute = [
  {
    path: routeSubDirectory+'/event/add',
    name: 'Add Event',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/event/add-event')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view event
const viewEventRoute = [
  {
    path: routeSubDirectory+'/event/view',
    name: 'View Event',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/event/view-event')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit event
const editEventRoute = [
  {
    path: routeSubDirectory+'/event/edit',
    name: 'Edit Event',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/event/edit-event')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// training
const trainingRoutes = [
  {
    path: routeSubDirectory+'/training',
    name: 'Training',
    labelKey:'nav.training',
    icon: 'book-open',
    component: () => lazyLoadView(import('@views/pages/apps/training/training')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add training
const addTrainingRoute = [
  {
    path: routeSubDirectory+'/training/add',
    name: 'Add Training',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/training/add-training')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view training
const viewTrainingRoute = [
  {
    path: routeSubDirectory+'/training/view',
    name: 'View Training',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/training/view-training')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit training
const editTrainingRoute = [
  {
    path: routeSubDirectory+'/training/edit',
    name: 'Edit Training',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/training/edit-training')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// union
const unionRoutes = [
  {
    path: routeSubDirectory+'/union',
    name: 'Union',
    labelKey:'nav.union',
    icon: 'shield',
    component: () => lazyLoadView(import('@views/pages/apps/union/union')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add union
const addUnionRoute = [
  {
    path: routeSubDirectory+'/union/add',
    name: 'Add Union',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/union/add-union')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view union
const viewUnionRoute = [
  {
    path: routeSubDirectory+'/union/view',
    name: 'View Union',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/union/view-union')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit union
const editUnionRoute = [
  {
    path: routeSubDirectory+'/union/edit',
    name: 'Edit Union',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/union/edit-union')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// federation
const federationRoutes = [
  {
    path: routeSubDirectory+'/federation',
    name: 'Federation',
    labelKey:'nav.federation',
    icon: 'flag',
    component: () => lazyLoadView(import('@views/pages/apps/federation/federation')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add federation
const addFederationRoute = [
  {
    path: routeSubDirectory+'/federation/add',
    name: 'Add Federation',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/federation/add-federation')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view federation
const viewFederationRoute = [
  {
    path: routeSubDirectory+'/federation/view',
    name: 'View Federation',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/federation/view-federation')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit federation
const editFederationRoute = [
  {
    path: routeSubDirectory+'/federation/edit',
    name: 'Edit Federation',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/federation/edit-federation')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// industry
const industryRoutes = [
  {
    path: routeSubDirectory+'/industry',
    name: 'Industry',
    labelKey:'nav.industry',
    icon: 'tool',
    component: () => lazyLoadView(import('@views/pages/apps/industry/industry')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add industry
const addIndustryRoute = [
  {
    path: routeSubDirectory+'/industry/add',
    name: 'Add Industry',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/industry/add-industry')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view industry
const viewIndustryRoute = [
  {
    path: routeSubDirectory+'/industry/view',
    name: 'View Industry',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/industry/view-industry')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit industry
const editIndustryRoute = [
  {
    path: routeSubDirectory+'/industry/edit',
    name: 'Edit Industry',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/industry/edit-industry')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// employer
const employerRoutes = [
  {
    path: routeSubDirectory+'/employer',
    name: 'Employer',
    labelKey:'nav.employer',
    icon: 'briefcase',
    component: () => lazyLoadView(import('@views/pages/apps/employer/employer')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add employer
const addEmployerRoute = [
  {
    path: routeSubDirectory+'/employer/add',
    name: 'Add Employer',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/employer/add-employer')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view employer
const viewEmployerRoute = [
  {
    path: routeSubDirectory+'/employer/view',
    name: 'View Employer',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/employer/view-employer')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit employer
const editEmployerRoute = [
  {
    path: routeSubDirectory+'/employer/edit',
    name: 'Edit Employer',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/employer/edit-employer')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// grievance
const grievanceRoutes = [
  {
    path: routeSubDirectory+'/grievance',
    name: 'Grievance',
    label: 'Member',
    labelKey:'nav.member',
    header: 'Grievance',
    headerKey:'nav.grievance',
    icon: 'message-square',
    component: () => lazyLoadView(import('@views/pages/apps/grievance/grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// grievance another version for users withut the label
const grievanceRoutesVersion = [
  {
    path: routeSubDirectory+'/grievance',
    name: 'Grievance',
    labelKey:'nav.grievance',
    icon: 'message-square',
    component: () => lazyLoadView(import('@views/pages/apps/grievance/grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add grievance
const addGrievanceRoute = [
  {
    path: routeSubDirectory+'/grievance/add',
    name: 'Add Grievance',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/grievance/add-grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view grievance
const viewGrievanceRoute = [
  {
    path: routeSubDirectory+'/grievance/view',
    name: 'View Grievance',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/grievance/view-grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit grievance
const editGrievanceRoute = [
  {
    path: routeSubDirectory+'/grievance/edit',
    name: 'Edit Grievance',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/grievance/edit-grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

//////////////////////////////////////////////////////////////////////////////////////////

// union grievance
const unionGrievanceRoutes = [
  {
    path: routeSubDirectory+'/grievance-union',
    name: 'Union Grievance',
    labelKey:'nav.union',
    label: 'Union',
    icon: 'shield',
    component: () => lazyLoadView(import('@views/pages/apps/grievance-union/grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add union grievance
const addUnionGrievanceRoute = [
  {
    path: routeSubDirectory+'/grievance-union/add',
    name: 'Add Union Grievance',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/grievance-union/add-grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view union grievance
const viewUnionGrievanceRoute = [
  {
    path: routeSubDirectory+'/grievance-union/view',
    name: 'View Union Grievance',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/grievance-union/view-grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit union grievance
const editUnionGrievanceRoute = [
  {
    path: routeSubDirectory+'/grievance-union/edit',
    name: 'Edit Union Grievance',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/grievance-union/edit-grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// federation grievance
const federationGrievanceRoutes = [
  {
    path: routeSubDirectory+'/grievance-federation',
    name: 'Federation Grievance',
    labelKey:'nav.federation',
    label: 'Federation',
    icon: 'flag',
    component: () => lazyLoadView(import('@views/pages/apps/grievance-federation/grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add federation grievance
const addFederationGrievanceRoute = [
  {
    path: routeSubDirectory+'/grievance-federation/add',
    name: 'Add Federation Grievance',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/grievance-federation/add-grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view federation grievance
const viewFederationGrievanceRoute = [
  {
    path: routeSubDirectory+'/grievance-federation/view',
    name: 'View Federation Grievance',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/grievance-federation/view-grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit federation grievance
const editFederationGrievanceRoute = [
  {
    path: routeSubDirectory+'/grievance-federation/edit',
    name: 'Edit Federation Grievance',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/grievance-federation/edit-grievance')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]



// apply for membership 
const applyMembershipRoutes = [
  {
    path: routeSubDirectory+'/union/apply',
    name: 'Membership',
    labelKey:'nav.membership',
    header: 'Union',
    headerKey:'nav.union',
    icon: 'shield',
    component: () => lazyLoadView(import('@views/pages/apps/union/apply')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// wra
const wraRoutes = [
  {
    path: routeSubDirectory+'/wra',
    name: 'WRA',
    labelKey:'nav.wra',
    label: 'WRA',
    subLabel: 'Work Related Accident',
    subLabelKey:'nav.wraSub',
    icon: 'zap',
    component: () => lazyLoadView(import('@views/pages/apps/wra/wra')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add wra
const addWraRoute = [
  {
    path: routeSubDirectory+'/wra/add',
    name: 'Add WRA',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/wra/add-wra')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view wra
const viewWraRoute = [
  {
    path: routeSubDirectory+'/wra/view',
    name: 'View WRA',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/wra/view-wra')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit wra
const editWraRoute = [
  {
    path: routeSubDirectory+'/wra/edit',
    name: 'Edit WRA',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/wra/edit-wra')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]



// ls
const lsRoutes = [
  {
    path: routeSubDirectory+'/ls',
    name: 'LSR',
    labelKey:'nav.lsr',
    label: 'LSR',
    subLabel: 'Legal Service Request',
    subLabelKey:'nav.lsrSub',
    icon: 'folder',
    component: () => lazyLoadView(import('@views/pages/apps/ls/ls')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add ls
const addLsRoute = [
  {
    path: routeSubDirectory+'/ls/add',
    name: 'Add LSR',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/ls/add-ls')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view ls
const viewLsRoute = [
  {
    path: routeSubDirectory+'/ls/view',
    name: 'View LSR',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/ls/view-ls')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit ls
const editLsRoute = [
  {
    path: routeSubDirectory+'/ls/edit',
    name: 'Edit LSR',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/ls/edit-ls')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// content
const contentRoutes = [
  {
    path: routeSubDirectory+'/content',
    name: 'Content',
    labelKey:'nav.content',
    label: 'Content',
    icon: 'book',
    component: () => lazyLoadView(import('@views/pages/apps/content/content')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add content
const addContentRoute = [
  {
    path: routeSubDirectory+'/content/add',
    name: 'Add Content',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/content/add-content')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view content
const viewContentRoute = [
  {
    path: routeSubDirectory+'/content/view',
    name: 'View Content',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/content/view-content')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit content
const editContentRoute = [
  {
    path: routeSubDirectory+'/content/edit',
    name: 'Edit Content',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/content/edit-content')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// union content
const unionContentRoutes = [
  {
    path: routeSubDirectory+'/content-union',
    name: 'Union Content',
    labelKey:'nav.content',
    label: 'Content',
    icon: 'book',
    component: () => lazyLoadView(import('@views/pages/apps/content-union/content')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add union content
const addUnionContentRoute = [
  {
    path: routeSubDirectory+'/content-union/add',
    name: 'Add Union Content',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/content-union/add-content')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view union content
const viewUnionContentRoute = [
  {
    path: routeSubDirectory+'/content-union/view',
    name: 'View Union Content',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/content-union/view-content')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit union content
const editUnionContentRoute = [
  {
    path: routeSubDirectory+'/content-union/edit',
    name: 'Edit Union Content',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/content-union/edit-content')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// editor event
const eventEditorRoutes = [
  {
    path: routeSubDirectory+'/event-editor',
    name: 'Editor Event',
    labelKey:'nav.event',
    label: 'Event',
    icon: 'calendar',
    component: () => lazyLoadView(import('@views/pages/apps/event-editor/event')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// add editor event
const addEditorEventRoute = [
  {
    path: routeSubDirectory+'/event-editor/add',
    name: 'Add Editor Event',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/event-editor/add-event')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// view editor event
const viewEditorEventRoute = [
  {
    path: routeSubDirectory+'/event-editor/view',
    name: 'View Editor Event',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/event-editor/view-event')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// edit editor event
const editEditorEventRoute = [
  {
    path: routeSubDirectory+'/event-editor/edit',
    name: 'Edit Editor Event',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/event-editor/edit-event')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

//////////////////////////////////////////////////////////////////////

// union member application
const memberApplicationRoute = [
  {
    path: routeSubDirectory+'/union/application',
    name: 'Application',
    labelKey:'nav.application',
    icon: 'user-plus',
    component: () => lazyLoadView(import('@views/pages/apps/union/application/application')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// union member cancellation
const memberCancellationRoute = [
  {
    path: routeSubDirectory+'/union/cancellation',
    name: 'Cancellation',
    labelKey:'nav.cancellation',
    icon: 'user-minus',
    component: () => lazyLoadView(import('@views/pages/apps/union/cancellation/cancellation')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// report
const reportRoute = [
  {
    path: routeSubDirectory+'/report/report',
    name: 'Report',
    labelKey:'nav.report',
    header: 'Report',
    headerKey:'nav.report',
    icon: 'pie-chart',
    component: () => lazyLoadView(import('@views/pages/apps/report/report')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// profile
const profileRoute = [
  {
    path: routeSubDirectory+'/profile/profile',
    name: 'Profile',
    icon: 'user',
    component: () => lazyLoadView(import('@views/pages/apps/profile')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// message
const messageRoute = [
  {
    path: routeSubDirectory+'/message/message',
    name: 'Message',
    labelKey:'nav.message',
    icon: 'mail',
    component: () => lazyLoadView(import('@views/pages/apps/message/message')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// message compose
const messageComposeRoute = [
  {
    path: routeSubDirectory+'/message/compose',
    name: 'Compose',
    icon: 'mail',
    component: () => lazyLoadView(import('@views/pages/apps/message/compose')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]




///////////////////////////////////////////////////////////////////////////////////

// course
const courseRoutes = [
  {
    path: routeSubDirectory+'/course/index',
    name: 'Course',
    icon: 'mail',
    component: () => lazyLoadView(import('@views/pages/apps/course/index')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// chapter
const chapterRoutes = [
  {
    path: routeSubDirectory+'/chapter/index',
    name: 'Chapter',
    icon: 'mail',
    component: () => lazyLoadView(import('@views/pages/apps/chapter/index')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// lecture
const lectureRoutes = [
  {
    path: routeSubDirectory+'/lecture/index',
    name: 'Lecture',
    icon: 'mail',
    component: () => lazyLoadView(import('@views/pages/apps/lecture/index')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// gebiBoard
const gebiBoardRoutes = [
  {
    path: routeSubDirectory+'/gebiboard/index',
    name: 'Gebi Board',
    icon: 'users',
    component: () => lazyLoadView(import('@views/pages/apps/gebiboard/index')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// settings
const settingsRoutes = [
  {
    path: routeSubDirectory+'/setting/index',
    name: 'Settings',
    icon: 'settings',
    component: () => lazyLoadView(import('@views/pages/secondary/error-404')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// addCourse
const addCourseRoutes = [
  {
    path: routeSubDirectory+'/course/add',
    name: 'Add Course',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/course/add')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// addChapter
const addChapterRoutes = [
  {
    path: routeSubDirectory+'/chapter/add',
    name: 'Add Chapter',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/chapter/add')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]



// addLecture
const addLectureRoutes = [
  {
    path: routeSubDirectory+'/lecture/add',
    name: 'Add Lecture',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/lecture/add')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// addFeedback
const addFeedbackRoutes = [
  {
    path: routeSubDirectory+'/feedback/add',
    name: 'Add Feedback',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/feedback/add')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// addQuestion
const addQuestionRoutes = [
  {
    path: routeSubDirectory+'/question/add',
    name: 'Add Question',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/question/add')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// addTool
const addToolRoutes = [
  {
    path: routeSubDirectory+'/tool/add',
    name: 'Add Tool',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/tool/add')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// addSubchapter
const addSubchapterRoutes = [
  {
    path: routeSubDirectory+'/subchapter/add',
    name: 'Add Sub-Chapter',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/subchapter/add')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// subchapter editor
const subChapterEditorRoutes = [
  {
    path: routeSubDirectory+'/subchaptereditor/add',
    name: 'SubChapter Editor',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/subchaptereditor/add')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]



// chapters
const chaptersRoutes = [
  {
    path: routeSubDirectory+'/course/:id',
    name: 'Chapters',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/chapter/chapters')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// chapters
const subChaptersRoutes = [
  {
    path: routeSubDirectory+'/chapter/:pid/:id',
    name: 'SubChapters',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/subchapter/subchapters')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// content screen
const contentScreenRoutes = [
  {
    path: routeSubDirectory+'/chapter/content/:id',
    name: 'ContentScreen',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/content/content-screen')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]


// test screen
const testScreenRoutes = [
  {
    path: routeSubDirectory+'/chapter/test/:id',
    name: 'TestScreen',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/content/test-screen')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]

// tools
const toolsRoutes = [
  {
    path: routeSubDirectory+'/tools/:pid/:id',
    name: 'Tools',
    icon: 'plus',
    component: () => lazyLoadView(import('@views/pages/apps/tool/tools')),
    meta: { authRequired: true },
    props: (route) => ({ user: store.state.currentUser || {} }),
  },
]






const authProtectedRoutes = [
  ...dashboardRoutes,
  ...memberRoutes,
  ...messageRoute,
  ...unionContentRoutes,
  ...eventEditorRoutes,
  ...trainingRoutes,
  ...unionRoutes,
  ...federationRoutes,
  ...industryRoutes,
  ...employerRoutes,
  ...grievanceRoutes,
  ...unionGrievanceRoutes,
  ...federationGrievanceRoutes,
  ...reportRoute,
  ...logRoutes
]

const editorAuthProtectedRoutes = [
  ...dashboardRoutes,
  ...unionContentRoutes,
  ...eventEditorRoutes,
  ...trainingRoutes,
  ...reportRoute
]

const userAuthProtectedRoutes = [
  ...dashboardRoutes,
  //...memberRoutes,
  ...contentRoutes,
  ...eventRoutes,
  ...trainingRoutes,
  //...unionRoutes,
  //...federationRoutes,
  //...industryRoutes,
  //...employerRoutes,
  ...applyMembershipRoutes,
  ...messageRoute,
  ...grievanceRoutesVersion,
  ...wraRoutes,
  ...lsRoutes,
]


const userAuthProtectedRoutesWithMembershipRequest = [
  ...dashboardRoutes,
  //...courseRoutes,
  //...chapterRoutes,
  //...lectureRoutes,
  ...gebiBoardRoutes,
  //...settingsRoutes,
  //...addCourseRoutes,
  //...addChapterRoutes,
  //...addSubchapterRoutes,
  //...addLectureRoutes,
  //...addFeedbackRoutes,
  //...addQuestionRoutes,
  //...addToolRoutes,
  //...subChapterEditorRoutes

  //...memberRoutes,
  //...eventRoutes,
  //...trainingRoutes,
  //...unionRoutes,
  //...federationRoutes,
  //...industryRoutes,
  //...employerRoutes,
  //...applyMembershipRoutes
]

const userAuthProtectedRoutesWithoutGrievance = [
  ...dashboardRoutes,
  //...memberRoutes,
  ...eventRoutes,
  ...trainingRoutes,
  //...unionRoutes,
  //...federationRoutes,
  //...industryRoutes,
  //...employerRoutes,
  //...applyMembershipRoutes
]

const unionAuthProtectedRoutes = [
  ...dashboardRoutes,
  ...unionContentRoutes,
  //...memberRoutes,
  ...eventEditorRoutes,
  ...trainingRoutes,
  //...unionRoutes,
  //...federationRoutes,
  //...industryRoutes,
  //...employerRoutes,
  ...unionMemberRoutes,
  ...memberApplicationRoute,
  ...memberCancellationRoute,
  ...messageRoute,
  ...wraRoutes,
  ...lsRoutes,
  ...grievanceRoutes,
  ...unionGrievanceRoutes,
  ...reportRoute
]


const federationAuthProtectedRoutes = [
  ...dashboardRoutes,
  //...memberRoutes,
  ...unionContentRoutes,
  ...eventEditorRoutes,
  ...trainingRoutes,
  //...unionRoutes,
  //...federationRoutes,
  //...industryRoutes,
  //...employerRoutes,
  ...unionMemberRoutes,
  ...messageRoute,
  ...wraRoutes,
  ...lsRoutes,
  ...grievanceRoutes,
  ...unionGrievanceRoutes,
  ...federationGrievanceRoutes,
  ...reportRoute
]





const allRoutes = [...authRoutes, ...authProtectedRoutes, ...errorPagesRoutes, ...addMemberRoute, ...viewMemberRoute, ...editMemberRoute, ...editMemberOnceRoute, ...addEmployerRoute, ...viewEmployerRoute, ...editEmployerRoute, ...addIndustryRoute, ...viewIndustryRoute, ...editIndustryRoute, ...addFederationRoute, ...viewFederationRoute, ...editFederationRoute, ...addUnionRoute, ...viewUnionRoute, ...editUnionRoute, ...addGrievanceRoute, ...viewGrievanceRoute, ...editGrievanceRoute, ...addTrainingRoute, ...viewTrainingRoute, ...editTrainingRoute, ...addEventRoute, ...viewEventRoute, ...editEventRoute, ...editorAuthProtectedRoutes, ...userAuthProtectedRoutes, ...unionAuthProtectedRoutes, ...addUnionGrievanceRoute, ...viewUnionGrievanceRoute, ...editUnionGrievanceRoute, ...applyMembershipRoutes, ...addWraRoute, ...viewWraRoute, ...editWraRoute, ...addLsRoute, ...viewLsRoute, ...editLsRoute, ...addContentRoute, ...viewContentRoute, ...editContentRoute, ...addUnionContentRoute, ...viewUnionContentRoute, ...editUnionContentRoute, ...addEditorEventRoute, ...viewEditorEventRoute, ...editEditorEventRoute, ...addFederationGrievanceRoute, ...viewFederationGrievanceRoute, ...editFederationGrievanceRoute,...profileRoute,...messageComposeRoute,...courseRoutes,...chapterRoutes, ...lectureRoutes, ...gebiBoardRoutes, ...settingsRoutes, ...addCourseRoutes,
  ...addChapterRoutes,
  ...addSubchapterRoutes,
  ...addLectureRoutes,
  ...addFeedbackRoutes,
  ...addQuestionRoutes,
  ...addToolRoutes,
  ...subChapterEditorRoutes,
...chaptersRoutes,
...subChaptersRoutes,
...contentScreenRoutes,
...testScreenRoutes,
...toolsRoutes
]

export { allRoutes, authProtectedRoutes, editorAuthProtectedRoutes, userAuthProtectedRoutes, unionAuthProtectedRoutes, federationAuthProtectedRoutes, userAuthProtectedRoutesWithoutGrievance, userAuthProtectedRoutesWithMembershipRequest }

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@components/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 200,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    // error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
